module.exports = __webpack_public_path__ + "img/126.98b7e16d.svg";